import React, { useEffect, useRef, useState } from 'react';
import { useEventListener } from 'ahooks';
import { MessageList } from '@chatscope/chat-ui-kit-react';
import { isEmpty } from 'lodash';
import MessageItem from './MessageItem';
import { MAX_KEEP } from '../ducks';
import { NewMessageButton, MessageListWrapper } from 'components/storefront/Styles/ChatBox.styles';


const ScrollBottom = ({ target, scrollBottom, user }) => {
  const [isNewMessage, setIsNewMessage] = useState();

  const isBottom = () => {
    return target?.offsetHeight + target?.scrollTop >= target?.scrollHeight - 5;
  };

  // Thêm message listener khi component được mount
  /*
  window.addEventListener('message', event => {
    if (event.data === 'scrollToBottom') {
      scrollBottom();
    }
  });
*/
       // 🆕 FIX: Thêm listener trong useEffect + cleanup
     useEffect(() => {
       const handleMessage = event => {
         if (event.data === 'scrollToBottom') scrollBottom();
       };
       window.addEventListener('message', handleMessage);
       return () => {
         window.removeEventListener('message', handleMessage);
       };
     }, [scrollBottom]);

  useEventListener(
    'scroll',
    () => {
      if (isBottom()) {
        setIsNewMessage(false);
      } else {
        setIsNewMessage(true);
      }
    },
    { target },
  );

  return isNewMessage ? (
    <NewMessageButton onClick={scrollBottom} bottom={isEmpty(user) ? '45px' : '5px'}>
      <i className="fa-solid fa-angles-down"></i>
    </NewMessageButton>
  ) : null;
};

const ChatBox = ({
  messages = [],
  onClickMessage,
  user = {},
  onShowBanModal,
  onShowDeleteModal,
  marginTop,
  colorsConfig = {},
  ...otherProps
}) => {
  if (messages.length > MAX_KEEP) {
    messages = messages.slice(-MAX_KEEP);
  }
  const listRef = useRef(null);
  const scrollDemoRef = useRef(null);

       useEffect(() => {
       scrollDemoRef.current = document.querySelector('.scrollbar-container');
     }, []);
     // 🆕 Giới hạn message 1 lần (không mutate prop)
     const safeMessages = messages.length > MAX_KEEP
       ? messages.slice(-MAX_KEEP)
       : messages;
       /*
  const scrollDemo = document.querySelector('.scrollbar-container');
  */
  const scrollBottom = () => {
    try {
      const { scrollToBottom } = listRef?.current || {};
      scrollToBottom && scrollToBottom();
    } catch (error) {}
  };
  
  const getColorTag = data => {
    if (colorsConfig?.data && data?.user) {
      const colors = colorsConfig?.data ?? [];
      const userLevel = data?.user?.level ?? 1;

      if (colors && userLevel) {
        return colors[userLevel - 1];
      }

      return '';
    }

    return '';
  };
  
  return (
    <MessageListWrapper marginTop={marginTop}>
      <MessageList {...otherProps} ref={listRef}>
        {safeMessages.map(data => (
          <MessageItem
            onShowBanModal={onShowBanModal}
            onShowDeleteModal={onShowDeleteModal}
            data={data}
            user={user}
            onClickMessage={onClickMessage}
            key={data.id || data.idTmp}
            colorTag={getColorTag(data)}
          />
        ))}
      </MessageList>
      
      <ScrollBottom target={scrollDemoRef.current} scrollBottom={scrollBottom} user={user} />

    </MessageListWrapper>
  );
};

export default ChatBox;
